export class Currency {
  value: number
  constructor(value: string | number) {
    this.value = Number(value)
  }

  public toString(): string {
    return this.value.toFixed(2)
  }

  public toNumber(): number {
    return this.value
  }
}
